import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

import { Button, MaskedInput } from '@smartplatform/ui';
import DateEdit from './DateEdit';
import './style.scss';

export const dateFormat = 'dd.MM.yyyy';

@observer
export default class AppointmentDates extends React.Component {

	@observable dates = [];
	@observable editing = false;
	
	constructor(props) {
		super(props);
		console.log('AppointmentDates', props);
		const dateStrings = props.value || [];
		this.dates = dateStrings.map(dateStr => parse(dateStr, dateFormat, new Date()));
	}
	
	onAddDate = () => {
		this.dates.push(new Date());
		this.save();
	};
	
	onDateChange = (i, date) => {
		this.dates[i] = date;
		this.save();
	};
	
	onDateDelete = i => {
		this.dates.splice(i, 1);
		console.log('onDateDelete', i, this.dates);
		this.save();
	};
	
	save = () => {
		const dateStrings = this.dates.map(date => format(date, dateFormat));
		this.props.onChange && this.props.onChange(dateStrings);
	};
	
	render() {
		return <div className="appointment-dates">
			{this.dates.map((date, i) => (
				<DateEdit
					key={i}
					value={date}
					onChange={date => this.onDateChange(i, date)}
					onDelete={() => this.onDateDelete(i)}
				/>
			))}
			<Button onClick={this.onAddDate} className="btn-primary">Добавить</Button>
		</div>;
	}
	
}
